import React, { useEffect, useRef, useState } from 'react';
import InnerHeader from '../etc/innerheader';
import { getFetch } from '../../fetch/fetch';
import { addZeroIfOne } from '../../dashboard/components/controls/etc/etcfunctions';
import styles from "./mobilecontents.module.css";
import MenuBar from '../etc/\bmovingUnderbarMenu';
import MobileContentsSubmit from './mobilecontentssubmit';
import CoinModal from '../restaurant/modal/coinmodal';
import { IonApp, IonToast } from '@ionic/react';
import MobileModal from '../etc/mobilemodal';
import MobileModalCoin from '../etc/mobilemodalcoin';
import MobileContentsStatus from './mobilecontentsstatus';

interface MenuItem {
    key: string;
    label: string;
}

const menuItems1: MenuItem[] = [
    { key: "submit", label: "컨텐츠 구매" },
    { key: "status", label: "신청 현황" },
];

const MobileContentsBuy: React.FC<any> = (props) => {

    const headerRef = useRef<HTMLDivElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);
    const [currentMenu, setCurrentMenu] = useState("submit");
    const [bodyHeight, setBodyHeight] = useState(0);
    const [selectedContent, setSelectedContent] = useState<any>(null);


    const [availableCharge, setAvailableCharge] = useState(0);
    const [availableChargeString, setAvailableChargeString] = useState("");


    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    const [showToast2, setShowToast2] = useState(false);
    const [toastMessage2, setToastMessage2] = useState("");

    const [update, setUpdate] = useState(0);

    const [statusDivHeight, setStatusDivHeight] = useState(0);
    const [phoneNumbers, setPhoneNumbers] = useState<string[]>([]);

    const topDivRef = useRef<any>(null);


    const caculateBodyHeight = () => {
        setTimeout(() => {

            if (!headerRef || !headerRef.current) {
                console.log("headerRef is null2");
                return;
            }

            if (!menuRef || !menuRef.current) {
                console.log("menuRef is null2");
                return;
            }

            const value = +getComputedStyle(document.documentElement).getPropertyValue("--sat").split("p")[0];
            const totalHeight = window.innerHeight;
            const safeareaTop = value;
            console.log(headerRef.current);
            const headerHeight = headerRef.current.offsetHeight;
            const menuHeight = menuRef.current.offsetHeight;

            const lastHeight = totalHeight - safeareaTop - headerHeight - menuHeight;



            setBodyHeight(lastHeight);

        }, 50);
    }


    useEffect(() => {

        caculateBodyHeight();

        window.addEventListener("resize", caculateBodyHeight);

        return () => window.removeEventListener("resize", caculateBodyHeight);

    }, [headerRef, menuRef]);

    useEffect(() => {

        if (!topDivRef || !topDivRef.current) {
            return;
        }

        const calculateStatusDivHeight = () => {

            setTimeout(() => {

                if (!topDivRef || !topDivRef.current) {
                    return;
                }

                const totalHeight = window.innerHeight;
                const topDivHeight = topDivRef.current.offsetHeight;

                const statusDivHeight = totalHeight - topDivHeight;


                console.log("statusDivHeight", statusDivHeight);

                setStatusDivHeight(statusDivHeight);

            }, 20);

        }

        calculateStatusDivHeight();

        window.addEventListener("resize", () => calculateStatusDivHeight());

        return () => window.removeEventListener("resize", () => calculateStatusDivHeight());

    }, [topDivRef]);




    const handleCurrentMenu = (menu: string) => {
        setCurrentMenu(menu);
    }



    const handleToastMessage = (message: string) => {
        setToastMessage(message);
        setShowToast(true);
    }

    const handleToastMessage2 = (message: string) => {
        setToastMessage2(message);
        setShowToast2(true);
    }

    const letsUpdate = () => {
        setUpdate(Math.random());
    }

    useEffect(() => {

        getPhoneNumbers();

    }, []);

    const getPhoneNumbers = async () => {

        try {

            const result: any = await getFetch("/dashboard/restaurant/getphonenumbers");


            const phoneNumbers: string[] = [];

            if (result.myPhoneNumber) {
                phoneNumbers.push(result.myPhoneNumber);
            }

            if (result.parentPhoneNumbers) {
                //동일한게 있으면 추가하지 않음
                result.parentPhoneNumbers.forEach((item: any) => {
                    if (phoneNumbers.indexOf(item) === -1) {
                        phoneNumbers.push(item);
                    }
                });
            }


            setPhoneNumbers([...phoneNumbers]);

        } catch (e) {
        }

    }






    return (
        <div>
            <div ref={topDivRef}>
                <InnerHeader title="컨텐츠 구매" headerRef={headerRef}
                />
                <MenuBar menuItems={menuItems1} handleCurrentMenu={handleCurrentMenu} menuRef={menuRef} />
            </div>


            <div style={{
                height: bodyHeight,
                overflowY: "auto",
                overflowX: "hidden",
                paddingTop: "1rem"
            }} className={styles.body}>
                {
                    currentMenu === "submit" ? <MobileContentsSubmit
                        bodyHeight={bodyHeight}
                        phoneNumbers={phoneNumbers}
                        user={props.user}
                    /> : null
                }
                {
                    currentMenu === "status" ?
                        <MobileContentsStatus
                            socket={props.socket}
                            statusDivHeight={statusDivHeight}
                            handleToastMessage={handleToastMessage}
                            handleToastMessage2={handleToastMessage2}
                            letsUpdate={letsUpdate}
                            user={props.user}
                            phoneNumbers={phoneNumbers}
                        /> : null
                }
            </div>






            <IonToast
                isOpen={showToast}
                onDidDismiss={() => { setShowToast(false); setToastMessage(""); }}
                message={toastMessage}
                duration={1500}
                position="top"
                color="danger"
            />

        </div>
    )
}

export default MobileContentsBuy;